export function integrationInventoryAssetsUrl(
  spaceId: string,
  integrationMrn: string,
): URL {
  const inventoryUrl = new URL(window.location.origin);
  inventoryUrl.pathname = "/space/inventory";
  inventoryUrl.searchParams.set("spaceId", spaceId);
  inventoryUrl.searchParams.set(
    "label",
    JSON.stringify({
      "mondoo.com/integration-mrn": integrationMrn,
    }),
  );
  return inventoryUrl;
}
